import { getPersonalDetailsForm, getSelectedForm } from '../../../selectors/ugMotorInsurance/personalDetails';
import {
    getEmploymentDetailsForm,
    getPersonalDataProcessingConsent,
} from '../../../selectors/ugMotorInsurance/employmentDetails';
import { getIsApiPending } from '../../../selectors/ugMotorInsurance/payloadCollection';
import { apiTransitionPayloadCollection } from '../../../actions/ugMotorInsurance/payloadCollection';
import { getAccessToken } from '../../../selectors/ugMotorInsurance/payments';
import axios from 'axios';
import {
    getCustomerIdValue,
    getInsuranceQuotationIdValue,
    getVehicleRecordIdValue,
} from '../../../selectors/ugMotorInsurance/quote';
import {
    setPersonalDetailsSubmittedValue,
    setSelectedFormValue,
} from '../../../actions/ugMotorInsurance/personalDetails';
import { setEmploymentDetailsSubmittedValue } from '../../../actions/ugMotorInsurance/employmentDetails';
import { setShowTaggingErrorModal, setTaggingErrorMessage } from '../../../actions/ugMotorInsurance/quote';
import { collectLoginDetails } from '../../../actions/ugMotorInsurance/auth';
import { navigateToNextOfKin, navigateToPersonalDetails } from '../../../actions/ugMotorInsurance/routing';

export const submitPersonalDetailsService = async (store, next, action) => {
    const state = store.getState();

    if (getIsApiPending(state)) {
        return next(action);
    }

    store.dispatch(setShowTaggingErrorModal(false));
    store.dispatch(setTaggingErrorMessage(null));
    store.dispatch(apiTransitionPayloadCollection.pending());

    try {
        await makeSubmission(state);

        const selectedForm = getSelectedForm(state);
        const personalDataProcessingConsent = getPersonalDataProcessingConsent(state);

        store.dispatch(setPersonalDetailsSubmittedValue(true));

        if (personalDataProcessingConsent.value === true) {
            store.dispatch(setEmploymentDetailsSubmittedValue(true));
        }

        if (selectedForm === 'personalDetails') {
            store.dispatch(navigateToPersonalDetails());
            store.dispatch(setSelectedFormValue('employmentDetails'));
        }

        if (selectedForm === 'employmentDetails') {
            store.dispatch(navigateToNextOfKin());
        }
    } catch (error) {
        console.error(error);

        store.dispatch(setPersonalDetailsSubmittedValue(false));
        store.dispatch(setEmploymentDetailsSubmittedValue(false));
        const status = error?.response?.status;

        if (status === 401) {
            store.dispatch(collectLoginDetails());
        }

        store.dispatch(setTaggingErrorMessage('Something went wrong. Try again later'));
        store.dispatch(setShowTaggingErrorModal(true));
    } finally {
        store.dispatch(apiTransitionPayloadCollection.initial());
    }

    return next(action);
};

const getLastName = (personalDetails) => {
    const middleName = personalDetails.middleName?.value || '';
    const lastName = personalDetails.lastName?.value || '';

    return [middleName, lastName].filter(Boolean).join(' ');
};

const payloadCollection = (state) => {
    const personalDetails = getPersonalDetailsForm(state);
    //const agent = getAgentForm(state);
    const employmentDetails = getEmploymentDetailsForm(state);

    const customerId = getCustomerIdValue(state);
    const vehicleRecordId = getVehicleRecordIdValue(state);
    const insuranceQuotationId = getInsuranceQuotationIdValue(state);

    /*
     const agentPayload = {
        countryCode: 'KE',
        reffererCode: agent.agentCode.value || 'NA',
        reffererType: agent.intermediaryType.value || 'NA',
    };
    */

    const personalDetailsPayload = {
        customerId: customerId.value,
        quotationId: insuranceQuotationId.value,
        vehicleId: vehicleRecordId.value,
        firstName: personalDetails.firstName.value,
        lastName: getLastName(personalDetails),
        emailAddress: personalDetails.email.value,
        dateOfBirth: personalDetails.dob.value,
        idNumber: personalDetails.idNumber.value,
        idCardNumber: personalDetails.idCardNumber.value || 'N/A',
        nationality: personalDetails.nationality.value,
        phoneNumber: personalDetails.phoneNumber.value,
        tinNumber: personalDetails.tinNumber.value,
        postalAddress: personalDetails.postalAddress.value || 'N/A',
        gender: personalDetails.gender.value,
        occupation: employmentDetails.occupation.value || 'N/A',
        personalDataProcessingConsent: employmentDetails.personalDataProcessingConsent.value || false,
        childDataProcessingConsent: employmentDetails.childDataProcessingConsent?.value || false,
        commercialUseConsent: employmentDetails.marketingUseConsent?.value || false,
        maritalStatus: personalDetails.maritalStatus?.value || 'N/A',
        residentialStatus: personalDetails.residentialStatus?.value || 'N/A',
        townOrCity: personalDetails.townOrCity?.value || 'N/A',
        employmentStatus: employmentDetails.employmentStatus?.value || 'N/A',
        employerName: employmentDetails.employerName?.value || 'N/A',
        schemeName: employmentDetails.schemeName?.value || 'N/A',
        industryOrSector: employmentDetails.industryOrSector?.value || 'N/A',
        contractEndDate: employmentDetails.contractEndDate?.value || 'N/A',
        employmentNumber: employmentDetails.employmentNumber?.value || 'N/A',
        salaryRange: employmentDetails.salaryRange?.value || 'N/A',
        employerPostalAddress: employmentDetails.employerPostalAddress?.value || 'N/A',
        employerTownOrCity: employmentDetails.employerTownOrCity?.value || 'N/A',
        employerPhoneNumber: employmentDetails.employerPhoneNumber?.value || 'N/A',
        //TODO: add physical address
    };

    //  ...agentPayload,

    return {
        ...personalDetailsPayload,
    };
};

const makeSubmission = async (state) => {
    const loginData = getAccessToken(state);
    try {
        const url = '/om-api/ug-motor-insurance/submit/personal-details';
        return await axios.post(url, payloadCollection(state), {
            headers: {
                'Content-Type': 'application/json',
                accessToken: loginData.accessToken,
            },
        });
    } catch (e) {
        console.error(e);
        throw e;
    }
};
